import { memo } from 'react';
import GridReport from './GridReport';

const Grid = (props) => {
    const p = props.gridReportMemo;

    if (!p || !p.report) {
        return;
    }

    //    const p = props.gridReportMemo || { report: {} };

    //p.report = p.report || {};
    return (
        <>
            {
                (p) &&
                <GridReport
                    cellFunctions={p.cellFunctions}
                    checkboxColumn={p.checkboxColumn}
                    dataEndpoint={p.dataEndpoint}
                    eventDataLoaded={p.eventDataLoaded}
                    getSelectedRows={p.getSelectedRows}
                    getSelectedRowsCallback={p.getSelectedRowsCallback}
                    gridHeight={p.gridHeight}
                    id={p.id}
                    isRowSelectable={p.isRowSelectable}
                    language={p.language}
                    loginData={p.loginData}
                    onAddNew={p.onAddNew}
                    onDelete={p.onDelete}
                    onGridReady={p.onGridReady}
                    onRowDoubleClick={p.onRowDoubleClick}
                    onSelectionChanged={p.onSelectionChanged}
                    reportParams={p.reportParams}
                    refreshId={p.refreshId}
                    report={p.report}
                    rowMultiSelectWithClick={p.rowMultiSelectWithClick}
                    rowSelection={p.rowSelection}

                    buttonsOnTop={props.buttonsOnTop}
                />
            }
        </>
    )
}

export default memo(Grid);
